import { z } from 'zod';

const NotificationsSchema = z.object({
  category: z.string(),
  mediaRowName: z.string(),
  description: z.string(),
  name: z.string(),
  ruleName: z.string(),
});

const TaxonomySchema = z.object({
  id: z.number(),
  name: z.string(),
  type: z.string(),
  notifications: z.array(NotificationsSchema).optional(),
  get children() {
    return z.array(TaxonomySchema);
  },
});

export const GetResponseSchema = z.object({
  accountId: z.number(),
  creationDate: z.string(),
  id: z.number(),
  journeyId: z.number(),
  journeyName: z.string(),
  taxonomy: TaxonomySchema,
  type: z.string(),
  userRead: z.boolean(),
  uuid: z.string(),
  version: z.number(),
});

export const ListResponseSchema = z.object({
  items: z.array(GetResponseSchema),
  cursor: z.string().optional(),
  hasMore: z.boolean(),
});

export const FilterSchema = z.object({
  byDate: z.object({
    dateFrom: z.date(),
    dateTo: z.date(),
  }),
  campaigns: z.array(z.string()),
  platforms: z.array(z.string()),
  alertType: z.array(z.string()),
});

const SelectOptionSchema = z.object({
  value: z.string(),
  label: z.string(),
});

export const GetFilterResponseSchema = z.object({
  campaigns: z.array(SelectOptionSchema).prefault([]),
  platforms: z.array(SelectOptionSchema).prefault([]),
  categories: z.array(SelectOptionSchema).prefault([]),
});
